// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__SqOl_","item":"styles_item__16mh4","content":"styles_content__1_Ivd"};